/**
 * Entitlement の metricCode 定数定義
 *
 * プラン別の機能ゲーティングで使用する metricCode を一元管理する。
 * admin フロントエンド（PlanGate コンポーネント）と API 側で共通利用する。
 */

export const METRIC_CODES = {
  CUSTOM_DOMAIN: "custom_domain",
  CREDIT_HIDDEN: "credit_hidden",
  API_ACCESS: "api_access",
  EXTERNAL_INTEGRATION: "external_integration",
  PUBLIC_LOGIN: "public_login",
} as const;

export type MetricCode = (typeof METRIC_CODES)[keyof typeof METRIC_CODES];

export const VALID_METRIC_CODES: readonly MetricCode[] = Object.values(METRIC_CODES);
